<template>
  <div>
    <h3 class="mt-6 mb-4 text-base">
      Funding Used
    </h3>
    <pie-chart :chart-data="chartData" />
  </div>
</template>

<script>
export default {
  name: "FundingSplitBreakdown",
  props: {
    breakdown: {
      type: Object,
      required: true
    }
  },
  computed: {
    chartData() {
      const { remaining, used, requested } = this.breakdown;
      return {
        labels: ["Remaining", "Used", "Requested"],
        datasets: [
          {
            data: [remaining.toFixed(2), used.toFixed(2), requested.toFixed(2)],
            backgroundColor: ["#97D700", "#F5FBE6", "#DBDBDB"]
          }
        ]
      };
    }
  }
};
</script>
